var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('select-input',{attrs:{"setup":{
      'func': _vm.selectProperty,
      'args': {
        'model': _vm.action.action,
        'key': 'property_index',
        'prefix': 'send_message_',
        'options': _vm.properties,
        'taggable': true,
        'clearable': false,
        'createButton': {
          'title': _vm.$t('create_property_button').toString(),
          'callback': _vm.prepareNewProperty,
        },
        'notFoundOptionText': _vm.$t('flow_property_not_found').toString()
      }
    }}}),_c('multi-message-editor-with-media-input',{staticClass:"mb-0",attrs:{"setup":{
      'func': _vm.setFailVariants,
      'args': {
        'model': _vm.action.action,
        'key': 'fail_variants',
        'hasMedia': true,
        'maxMessagesCount': 1,
        'prefix': 'flow_send_message_sidebar_',
        'placeholders': _vm.placeholders,
        'targetToUpload': {
          'target': 'target',
          'target_id': _vm.editor.projectState.board.key,
        },
        'defaultValue': [{
          text: _vm.$t('fail_variants_default_message')
        }],
        'settingsStructure': {
          'pin': false,
          'disable_link_preview': false,
          'disable_notify': false,
          'remove_previous': false,
          'protect_content': false,
          'remove_after': 0,
        },
        'validation': 'required',
        'customMediaTypes': _vm.node.nodeProps.customMediaTypes,
      }
    }}},[_c('div',{staticClass:"flex gap-2",attrs:{"slot":"titleButton"},slot:"titleButton"},[_c('a-button',{staticClass:"px-1 p-0 flex justify-center items-center",class:{'active': _vm.typingAction},on:{"click":_vm.switchTyping}},[_c('span',{staticClass:"material-icons"},[_vm._v(" "+_vm._s(_vm.typingAction ? 'timer_off' : 'timer')+" ")])])],1)]),_c('user-input-action-additional-settings',{staticClass:"mt-2",attrs:{"action":_vm.action,"node-props":_vm.nodeProps,"node-sockets-actions":_vm.nodeSocketsActions,"editor":_vm.editor,"node":_vm.node}}),_c('create-new-property',{attrs:{"init-name":_vm.newProperty,"is-open":_vm.createNewPropertyIsOpen,"create-new-property":_vm.createNewProperty},on:{"update:isOpen":function($event){_vm.createNewPropertyIsOpen=$event},"update:is-open":function($event){_vm.createNewPropertyIsOpen=$event},"setProperty":function (ref) {
        var id = ref.id;

        return _vm.action.setPropertyIndex(id);
}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }